import { render, staticRenderFns } from "./MyApprovals_Leave.vue?vue&type=template&id=5a31622d&scoped=true"
import script from "./MyApprovals_Leave.vue?vue&type=script&lang=js"
export * from "./MyApprovals_Leave.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a31622d",
  null
  
)

export default component.exports